import { PAYMENT_GATEWAYS } from "./paymentGateway";

export const IYZIPAY_EMAIL_ERROR = "iyzipay_email_required";
export const IYZIPAY_PROFILE_PATH = "/account/details";

export function userHasValidIyzicoEmail(user) {
    const email = typeof user?.email === "string" ? user.email.trim() : "";
    if (!email) {
        return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return false;
    }
    return !email.toLowerCase().endsWith(".local");
}

/**
 * @returns {boolean} true if OK to continue (not iyzico, or email valid)
 */
export function ensureIyzicoEmailOrRedirect({ gateway, user, enqueueSnackbar, navigate, t, redirect = true }) {
    if (gateway !== PAYMENT_GATEWAYS.iyzipay) {
        return true;
    }
    if (userHasValidIyzicoEmail(user)) {
        return true;
    }
    enqueueSnackbar(t(redirect ? "iyzipayEmailRequired" : "iyzipayEmailRequiredProfile"), { variant: "warning" });
    if (redirect && typeof navigate === "function") {
        navigate(IYZIPAY_PROFILE_PATH);
    }
    return false;
}
